import IpubTimePicker from './src/main'

/* istanbul ignore next */
IpubTimePicker.install = function(Vue) {
  Vue.component(IpubTimePicker.name, IpubTimePicker)
}

export default IpubTimePicker
